import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { colors } from 'styles/variables';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import resultsPassed from 'assets/Correct_loop.gif';
import resultsFailed from 'assets/Incorrect_loop.gif';
import { createMediaBlock } from './media';
import uuid from 'uuidv4';
import { getSId } from '../utils';

const { lPink } = colors;

// - Interaction
//   - Row
//     - Column
//       - FiveStarRating
//         - FiveStarList
//           - Star (repeat)
//         - TextArea
//         - SubmitButton
//     - Column
//       - Text
//   - Row
//     - Column
//       - ContinueButton (repeat)

export type ResultsPageProps = InteractionProps & {
  //
};

export const createResultsPageContentBlock = (count: number) => {
  return createBlock('ResultsPageContent', [
    createBlock('ResultsPageContentPassed', [
      createBlock('Text', [], { props: { useBackgroundControls: true } }),
      // createBlock('Text', [], { props: { useBackgroundControls: true } }),
      // createBlock('Text', [], { props: { useBackgroundControls: true } }),
    ]),
    createBlock('ResultsPageContentFailed', [
      createBlock('Text', [], { props: { useBackgroundControls: true } }),
      // createBlock('Text', [], { props: { useBackgroundControls: true } }),
      // createBlock('Text', [], { props: { useBackgroundControls: true } }),
    ]),
    // createBlock('ResultsPageResult'),
  ]);
};

export const createResultsPageMediaBlock = (count: number) => {
  return createBlock('ResultsPageMedia', [
    createMediaBlock({
      src: resultsPassed,
      type: 'passed',
      child: 1,
      useBackgroundControls: true,
    }),
    createMediaBlock({
      src: resultsFailed,
      type: 'failed',
      child: 1,
      useBackgroundControls: true,
    }),
  ]);
};

const contentForColumn = (count: number) => (i: number) => {
  return [
    () => createResultsPageContentBlock(0),
    // () => createResultsPageMediaBlock(0),
    () => createBlock('ResultsPageResult'),
  ][i];
};

export const createResultsPageInteractionBlock = (props: ResultsPageProps) => {
  const {
    // lockDown = 0,
    graphType = 'circle',
    graphColor = lPink,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(
        contentForColumn(0),
        // props.columnCount,
        // props.columnsReversed
        0,
        true
      ),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        type: 'ResultsPage',
        name: props.name,
        sId: getSId('interaction'),
        graphType,
        graphColor,
        style: props.style,

        // lockDown,
      },
      meta: {
        subType: 'ResultsPage',
        layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
          props.columnsReversed ? 'Reversed' : ''
        }`,
      },
    }
  );
};

export const create = createResultsPageInteractionBlock;
export const interactionConfig = {};
